import { Expose } from 'class-transformer';
import { Model } from './model';

export class WhiteLabelUserComment extends Model {
  @Expose() rate: number;
  @Expose() comment: string;
  @Expose() studentName: string;
  @Expose() id: string;
}
